import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import ServiceCard from './ServiceCard';

const ServicesStyles = styled.section`
  width: 100vw;
  padding: 60px 0;
  background: white;

  .grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
    grid-gap: 30px;
  }

  @media only screen and (max-width: 768px) {
    .grid {
      grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    }
  }
`;

export default function Services({ services }) {
  return (
    <ServicesStyles>
      <div className="container grid">
        {services.map((service) => (
          <ServiceCard
            key={service.id}
            image={service.image.asset.url}
            title={service.name}
            content={service.blurb.en}
            slug={service.slug}
          />
        ))}
      </div>
    </ServicesStyles>
  );
}

Services.propTypes = {
  services: PropTypes.array.isRequired,
};
